module.exports = __webpack_public_path__ + "static/img/5.bf179bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/5.png
// module id = ceif
// module chunks = 0